import React from "react";
import { Link } from "react-router-dom";
import { dateFormat } from "../../utils/date";
import DataTable from "../../components/data-table";
import * as queryService from "../../services/query/query-service";
import * as Loader from "../../common/common";
export default class AllQuery extends React.Component {
  constructor() {
    super();
    this.state = {
      queryData: "",
      loading: true,
      headers: [
        { title: "Sr No", accessor: "id", index: 0, dataType: "string" },
        { title: "Subject", accessor: "subject", index: 1, dataType: "string" },
        { title: "Query", accessor: "message", index: 2, dataType: "string" },
        {
          title: "Submitted By",
          accessor: "userName",
          index: 3,
          dataType: "string",
        },
        {
          title: "Submitted On",
          accessor: "createdAt",
          index: 4,
          dataType: "string",
        },
        {
          title: "",
          accessor: "queryId",
          index: 5,
          cell: (row) => {
            return (
              <Link to={"../query/QueryDetails/" + row.queryId}>
                <span
                  className="fa fa-eye text-black"
                  style={{ fontSize: "20px" }}
                >
                  {" "}
                </span>{" "}
              </Link>
            );
          },
        },
      ],
    };
    this.getAllQuries = this.getAllQuries.bind(this);
  }

  componentDidMount() {
    this.getAllQuries();
  }

  async getAllQuries() {
    Loader.showLoader();
    let { response, err } = await queryService.getAllQueries();
    Loader.hideLoader();
    if (err) {
    } else if (response.data && response.data.err) {
    } else {
      let data = response.data.data;
      this.setState({
        queryData: data,
        loading: false,
      });
    }
  }
  render() {
    let queryList = [];
    if (this.state.queryData.length > 0) {
      let queryData = this.state.queryData;
      let userName = "";
      let message = "";
      queryList = queryData.map((query, index) => {
        if (query.userdetail !== null) {
          userName =
            query.userdetail.userName +
            "(" +
            query.userdetail.companyName +
            ")";
          message = query.message;
          if (message.length > 900) {
            message = message.substring(0, 50) + "...";
          }
          index += 1;
        }
        return Object.assign(
          {},
          {
            id: index,
            subject: query.subject,
            message: message,
            userName: userName,
            createdAt: dateFormat(query.createdAt),
            queryId: query.queryId,
          }
        );
      });
    }

    return (
      <div className="container queries-wrapper mt-2 mb-2 mr-2 ml-2">
        <div>
          <div className="row pt-3">
            <div className="col-md-12">
              <h4 className="d-xs-block d-sm-block d-md-none text-uppercase text-center mt-2 text-primary">
                {" "}
                Query List
              </h4>
              {
                !!this.state.queryData ? (
                  <DataTable
                    className="table"
                    keyField="id"
                    pagination={{
                      enabled: true,
                      pageLength: 15,
                      type: "long",
                    }}
                    title=""
                    width="100%"
                    headers={this.state.headers}
                    data={queryList}
                    noData="No records!"
                  />
                ) : (
                  ""
                )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}
